import React, { useState } from "react"

import { Flex, Box } from "reflexbox"
import styled from "@emotion/styled"

import { connect } from "react-redux"

import { graphql } from "gatsby"

import { NewsletterInput } from "../styled"

import { globalHistory } from "@reach/router"

import { showModalWithMessage } from "../../actions"

import {
  emailMarketingOptedIn,
  emailMarketingOptedInIdentify,
} from "../../segment"

// import { css } from "@emotion/react"
import ErrorText from "../errortext"
import EmailSuccess from "../emailsuccess"

import isEmail from "validator/lib/isEmail"

const { createApolloFetch } = require("apollo-fetch")

const fetch = createApolloFetch({
  uri: "https://mcstaging.nutrafol.com/graphql",
})

const emailSubscribeMutation = graphql`
  mutation SubscribeForNewsletters($email: String!) {
    subscribeForNewsletters(email: $email) {
      result {
        status
        message
      }
    }
  }
`

const FooterArrowButton = styled.button`
  height: 48px;
  line-height: 48px;
  background-color: Transparent;
  background-repeat: no-repeat;
  border: none;
  cursor: pointer;
  overflow: hidden;
  outline: none;
  &:before {
    display: inline-block;
    content: "\\e906";
    font-family: "icomoon" !important;
    font-weight: 500;
    font-size: 14px;
    color: #1f6360;
  }
  &.isFooter {
    &:before {
      @media (min-width: 768px) {
        transform: translateX(-12px);
      }
    }
  }
  &.isSidebar {
    &:before {
      @media (min-width: 768px) {
        transform: translateX(-12px);
      }
    }
  }
  &:focus {
    outline: 0;
  }
`

const EmailForm = styled.form`
  display: flex;
  &.isFooter {
    @media (min-width: 768px) {
      padding-left: 24px;
    }
    @media (min-width: 1048px) {
      width: auto;
    }
  }
  &.isSidebar {
    @media (min-width: 768px) {
      padding-left: 0;
      #subscribe-input {
        width: 114% !important;
      }
    }
  }
`

const ArrowContainer = styled(Flex)`
  justify-content: right;
  padding-right: 10px;
  @media (min-width: 1024px) {
    padding-right: 0;
  }
`

const EmailInput = (props) => {
  const currentLocation =
    globalHistory && globalHistory.location ? globalHistory.location.href : "/"

  const [value, updateValue] = useState("")
  const [error, setError] = useState("")
  const [successfullySubmitted, setSuccessfullySubmitted] = useState(false)

  const handleSubmit = (e) => {
    e.preventDefault()

    if (value === "") {
      return setError("This is a required field.")
    }
    if (!isEmail(value)) {
      return setError("Please enter a valid email address")
    }

    fetch({
      query: `mutation SubscribeForNewsletters($email: String!) {
          subscribeForNewsletters (email: $email) {
            result {
                status,
                message
            }
          }
        }
      `,
      variables: { email: value },
    })
      .then((res) => {
        const status = res.data.subscribeForNewsletters.result.status
        let content = res.data.subscribeForNewsletters.result.message
        let title = ""
        if (parseInt(status) === 403) {
          title = "Something went wrong"
          content = "There was a problem with the subscription: " + content
        } else if (parseInt(status) === 200) {
          title = "Success!"
          content = "Thank you for signing up for our newsletter."
          setSuccessfullySubmitted(true)
          emailMarketingOptedIn(
            new Date().toISOString(),
            value,
            currentLocation
          )
          emailMarketingOptedInIdentify(value)
        } else {
          title = "Something went wrong"
          content =
            "Could not connect to the registration server. Please try again later."
        }
        props.showModalWithMessage({
          title: title,
          content: content,
        })
        return res
      })
      .then((json) => json)
      .catch((err) => console.log(err))

    setError("")
  }

  const handleChange = (e) => {
    e.preventDefault()
    setSuccessfullySubmitted(false)
    updateValue(e.target.value)
    setError("")
  }

  return (
    <>
      <EmailForm
        className={`form-wrapper ${props.footer ? "isFooter" : "isSidebar"}`}
        onSubmit={handleSubmit}
      >
        <Box width={[13 / 16, null]}>
          <NewsletterInput
            id={`${props.parent}-subscribe-input`}
            key={props.footer ? "isFooter" : "isSidebar"}
            className={error ? "error" : ""}
            value={value}
            onChange={handleChange}
            name="subscribe-input"
            placeholder={"Email address"}
          ></NewsletterInput>
        </Box>
        <ArrowContainer width={[3 / 16, null]}>
          <FooterArrowButton
            name="subscribe"
            className={props.footer ? "isFooter" : "isSidebar"}
          ></FooterArrowButton>
        </ArrowContainer>
      </EmailForm>
      {error ? <ErrorText text={error} footer={props.footer} /> : null}
      {successfullySubmitted ? (
        <EmailSuccess text={`Thanks for subscribing!`} footer={props.footer} />
      ) : null}
    </>
  )
}

export default connect(null, { showModalWithMessage })(EmailInput)
